// extracted by mini-css-extract-plugin
export default {"wrapper":"dkMnTUgdqhDeI70DPZGz","smallButton":"ugtnUBPhVR98uWmfnGIt"};